import React, { useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Route, Switch, Redirect, useHistory, useRouteMatch } from 'react-router';
import { Box } from '@material-ui/core';
import { ConnectorDealsNew, ConnectorDealsInProgress, ConnectorDealsDone, ConnectorTabsBar } from '..';
import { ConnectorDealsContextProvider, useConnector, useUser } from '../../../contexts';
import { StyledText } from '../../../components/StyledText';
import ConnectorGuide from '../../../components/PublishingGuide/ConnectorGuide';
import { ConnectorDealStatus } from '../../../types/types';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.default
  },
  title: {
    marginTop: '20px'
  }
}));

const ConnectorDealsHomeContainer = () => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const classes = useStyles();
  const { profile, fetchProfile, shouldShowIncompleteProfileGuide } = useConnector();
  const { userInfo } = useUser();

  const onTabSelected = (value: string) => {
    history.push(value);
  };

  const handleOpenProfile = async () => {
    history.push(`/connector/${profile.id}`);
  };

  useEffect(() => {
    if (userInfo && userInfo.profileId && profile.id !== userInfo.profileId) {
      fetchProfile(userInfo.profileId);
    }
    // fetch profile never changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile, userInfo]);

  return (
    <Box className={classes.root}>
      <StyledText className={classes.title} variant='h1'>Deals</StyledText>
      {shouldShowIncompleteProfileGuide
        && (
        <ConnectorGuide
          profile={profile}
          handleClick={handleOpenProfile}
        />
        )}
      <ConnectorTabsBar onTabSelected={onTabSelected} />
      <Switch>
        <Route
          path={`${path}/new`}
          render={() => (<ConnectorDealsNew />)}
        />
        <Route
          path={`${path}/inprogress`}
          render={() => <ConnectorDealsInProgress />}
        />
        <Route
          path={`${path}/done`}
          render={() => <ConnectorDealsDone />}
        />
        <Route render={() => (<Redirect to='/connector/deals/new' />)} />
      </Switch>
    </Box>
  );
};

const ConnectorDealsHome = () => (
  <ConnectorDealsContextProvider>
    <ConnectorDealsHomeContainer />
  </ConnectorDealsContextProvider>
);

export default ConnectorDealsHome;
